module.exports = __webpack_public_path__ + "static/media/b4.866729c5.webp";